module.exports = __webpack_public_path__ + "img/icon-share.4a518394.svg";